module.exports = __webpack_public_path__ + "static/img/gabrael-michael.10f749d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gabrael-michael.jpg
// module id = BNDW
// module chunks = 0